import React, { useState } from 'react';
// import DonutChart from 'donut-chart-js';

import BrandsData from '../Data/BrandsData';
// import PlaybackLine from '../Tools/PlaybackLine';

import play_circle from '../../Images/play-circle.svg';
import pause_circle from '../../Images/pause-circle.svg';
import video from '../../Images/video_thin.svg';
import Cross from '../../Images/x.svg';
import Spotify from '../../Images/logos/logo_spotify.png';

const PlacementItem = ({item,i,hover,setHover,width,playPressed,playing,setPlaying,dimensions,audioRef,playBack,setPlayBack}) => {
	// const [ playBack, setPlayBack ] = useState(0);
	const [ playVid, setPlayVid ] = useState(false);

	// const audioRef = useRef();
	// const donutRef = useRef();
	// useEffect(()=>{
	// 	donutRef.current = new DonutChart(document.getElementById('myChart'+item.name), {
	// 		data: [
	// 			{ label: 'blue', value: 0, color: 'rgb(60,150,255)' },
	// 			{ label: 'grey', value: 10, color: 'rgb(120,120,120)' },
	// 			// { label: 'blue', value: 180, color: '#B2CCFF' },
	// 			// { label: 'yellow', value: 70, color: '#FFE08C' },
	// 		],
	// 		holeSize: 0.6,
	// 		animationSpeed: 0.5,
	// 	});
	// },[]);

	// useEffect(()=>{
	// 	if(donutRef.current !== undefined){
	// 		if(donutRef.current.data !== undefined){
	// 			donutRef.current.data[0].value = playBack;
	// 			donutRef.current.data[1].value = audioRef.current.duration - playBack;
	// 		}
	// 	}
	// },[playBack,donutRef]);

	function playClicked() {
		const ref = document.getElementById(item.name);
		audioRef.current = ref;
		playPressed(item.name,i);
	}

	function videoClicked() {
		if(playing.id !== undefined){
			playPressed(playing.id,playing.i);
		}
	}

	// function playVideoClicked() {
	// 	if(playing.id !== undefined){
	// 		if(playing.play === true){
	// 			playPressed(playing.id);
	// 			setPlaying('');
	// 		}
	// 	}
	// 	setPlayVid(true);

	// 	// const script1 = document.createElement('script');
	// 	// const script2 = document.createElement('script');

	// 	// script1.src = 'https://fast.wistia.com/embed/medias/bgxvkoxhu5.jsonp';
	// 	// script1.async = true;

	// 	// script2.src = 'https://fast.wistia.com/assets/external/E-v1.js';
	// 	// script2.async = true;

	// 	// document.body.appendChild(script1);
	// 	// document.body.appendChild(script2);
	// }


	// function timeDisplay() {
	// 	let minutes = 0;
	// 	let seconds = '00';
	// 	let currentMinutes = '0';
	// 	let currentSeconds = '00';
	// 	if(audioRef.current !== undefined){
	// 		minutes = Math.floor(audioRef.current.duration/60);
	// 		seconds = Math.round(audioRef.current.duration%60);
	// 		if(seconds < 10) seconds = '0'+seconds;
	// 		currentMinutes = Math.floor(playBack/60);
	// 		currentSeconds = Math.round(playBack%60);
	// 		if(currentSeconds < 10) currentSeconds = '0'+currentSeconds;
	// 	}
	// 	return currentMinutes+':'+currentSeconds+' - '+minutes+':'+seconds;
	// }


	let thirdWidth = width/3-20;
	if(dimensions.width <= 750) thirdWidth = width/2-20;
	if(dimensions.width <= 550) thirdWidth = width-20;

	function videoOption() {
		if(item.videos[0] !== undefined && playVid === true){
			return <div className='modalBack flexCenter'>
			<div className='modal' style={{background:'black'}}>
				<div className='flexRight'>
					<div>
						<img src={Cross} alt='Cross' style={{height:34,marginTop:-40,marginLeft:-40}} className='absolute pointer' onClick={()=>{setPlayVid(false)}} />
					</div>
				</div>
				{/*<span className="wistia_embed wistia_async_bgxvkoxhu5 popover=true popoverAnimateThumbnail=true" style={{display:'inline-block',height:'84px',position:'relative',width:'150px'}}>&nbsp;</span>*/}
				{/*<div className="wistia_responsive_padding" style={{padding:'56.25% 0 0 0',position:'relative'}}>
					<div className="wistia_responsive_wrapper" style={{height:'100%',left:0,position:'absolute',top:0,width:'100%'}}>
						<div className="wistia_embed wistia_async_bgxvkoxhu5 seo=false videoFoam=true" style={{height:'100%',position:'relative',width:'100%'}}>
							<div className="wistia_swatch" style={{height:'100%',left:0,opacity:0,overflow:'hidden',position:'absolute',top:0,transition:'opacity 200ms',width:'100%'}}>
								<img src="https://fast.wistia.com/embed/medias/bgxvkoxhu5/swatch" style={{filter:'blur(5px)',height:'100%',objectFit:'contain',width:'100%',}} alt="hvivuiiviv"
										// aria-hidden="true" onLoad={()=>{this.parentNode.style.opacity=1}}
										/>
							</div>
						</div>
					</div>
				</div>*/}
				{/*<div className="wistia_embed wistia_async_videolink videoFoam=true"/>*/}
				{/*<video loop={false} autoPlay={true} width={width} controls={true}
						// ref={vidRef}
						>
					<source src={item.videos[0].video} type="video/mp4" />
				</video>*/}
			</div>
			</div>
		}
		return null
	}
	function brandsDisplayer() {
		let arr = [];
		for(let i = 0; i < item.brands.length; i++){
			arr.push(
				<div key={i}>
					{BrandsData[item.brands[i]] === undefined
						? null
						: <img src={BrandsData[item.brands[i]].img} alt='brands' style={{height:28,margin:4}} />
					}
				</div>
			)
		}
		return <div className='absolute flexRight' style={{width:thirdWidth,pointerEvents:'none',zIndex:40}}>{arr}</div>
	}

	return(
		<div>
		<div style={{marginRight:10,marginLeft:10,marginBottom:20}}>
			{item.songs[0] !== undefined
				? <audio id={item.name}
						// ref={audioRef}
						onTimeUpdate={()=>{setPlayBack(Math.floor(audioRef.current.currentTime))}}>
					<source src={item.songs[0].audio} type='audio/mpeg' />
					<source src={item.songs[0].audio} type='audio/wav' />
				</audio>
				: null
			}
			{(hover === i || playing.id === item.name || thirdWidth < 280) && item.songs[0] !== undefined
				? <div style={{height:thirdWidth,width:thirdWidth,backgroundImage:'radial-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0.3))',
						borderRadius:5,zIndex:2,backdropFilter:'blur(0px)'}}
						className='absolute flexCenter pointer' onClick={playClicked}>
					{playing.id === item.name && playing.play === true
						? <img src={pause_circle} alt='pause_circle' style={{height:80}} />
						: <img src={play_circle} alt='play_circle' style={{height:80}} />
					}
				</div>
				: item.videos[0] !== undefined && (hover === i || thirdWidth < 280)
					? <div style={{height:thirdWidth,width:thirdWidth,backgroundImage:'radial-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0))',
							borderRadius:5,zIndex:2,backdropFilter:'blur(0px)'}}
							className='absolute flexCenter pointer'
							onClick={videoClicked}>
						<span className={item.videos[0].spanClass} style={{display:'inline-block',height:thirdWidth,position:'absolute',width:thirdWidth,opacity:0}}>&nbsp;</span>
						<div className='flexCenter' style={{width:66,height:66,borderRadius:80,border:'2px solid white',background:'black'}}>
							<img src={video} alt='pause_circle' style={{height:40}} />
						</div>
					</div>
					: null
			}
			{item.spotify !== undefined
				? <div className='absolute flexRight' style={{width:thirdWidth,pointerEvents:'none',zIndex:40}}>
				<div className='flexCenter' style={{background:'rgb(32,215,96)',borderRadius:16,margin:6}}>
					<div style={{background:'black',borderRadius:16}} className='flexCenter'><img src={Spotify} alt='Spotify' style={{height:30}} /></div>
					<div style={{padding:4,marginRight:10,color:'black'}} className='appText bold'>{item.spotify} streams</div>
				</div>
				</div>
				: brandsDisplayer()
			}
			<div style={{height:thirdWidth,width:thirdWidth,background:'black',overflow:'hidden',borderRadius:5}}
					className='flexCenter pointer' onMouseEnter={()=>{setHover(i)}}>
				<img src={item.thumbnail} alt='album_art' style={{width:hover === i ? (100*item.thumbPos.size*1.1)+'%' : 100*item.thumbPos.size +'%',marginTop:item.thumbPos.t,marginLeft:item.thumbPos.l}} />
			</div>
			{(hover === i || playing.id === item.name || thirdWidth < 280) && item.songs[0] !== undefined
				? <div className='absolute appText bold flexHeightBottom' style={{marginTop:-51,height:50,width:thirdWidth,color:'white',zIndex:20,
						backgroundImage:'linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.4))',textShadow:'0px 0px 7px rgba(0,0,0,0.5)',
						pointerEvents:'none',borderBottom:'1px solid rgba(55,55,55,0.4)'}}>
					<div style={{marginLeft:10,marginBottom:6}}>{item.songs[0].name}</div>
				</div>
				: null
			}

			{/*<div style={{marginTop:-2,zIndex:20}} className='relative'>
				{playing.id === item.name
					? <PlaybackLine audioRef={audioRef} playBack={playBack} width={thirdWidth} dimensions={dimensions} height={2} />
					: <PlaybackLine audioRef={{current:undefined}} playBack={playBack} width={thirdWidth} dimensions={dimensions} height={2} />
				}
			</div>*/}
			{/*{audioRef.current !== undefined && (hover === i || (playing.id === item.name))
				? <div style={{width:thirdWidth,height:20,marginTop:-20,borderRadius:5,overflow:'hidden',zIndex:20}} className='flexHeightBottom relative'>
					<div style={{width:`${playBack/audioRef.current.duration*(thirdWidth)}%`,borderBottom:'8px solid rgb(255,20,170)'}}></div>
					<div style={{width:`${(thirdWidth)-(playBack/audioRef.current.duration*(thirdWidth))}%`,borderBottom:'8px solid rgba(120,120,120,0.7)'}}></div>
				</div>
				: <div style={{width:thirdWidth,height:20,marginTop:-20,borderRadius:5,overflow:'hidden'}} className='flexHeightBottom'>
				</div>
			}*/}
			{/*<canvas id={'myChart'+item.name} width='50px' height='50px'></canvas>*/}
		</div>
		{videoOption()}
		</div>
	)
}

export default PlacementItem;




